<template>
  <div>
    <router-link :to="`/referral`" tag="p" class="dashboard__back"
      >Back</router-link
    >
    <!-- the referrers details -->
    <div class="dashboard__booking">
      <div class="dashboard__booking-space">
        <!-- the referrers name -->
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Name</p>
          <p
            class="
              dashboard__booking-space-info-text
            "
          >
            {{ referrerName }}
          </p>
        </div>
        <!-- the referral code -->
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Referral Code</p>
          <p class="dashboard__booking-space-info-text">
            {{ referralCode }}
          </p>
        </div>
        <!-- the total number of referrals -->
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Number of Referrals</p>
          <p
            class="
              dashboard__booking-space-info-text
            "
          >
            {{ numberOfReferrals }}
          </p>
        </div>
        <!-- total referral earnings -->
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            Total Referral Earnings
          </p>
          <div class="dashboard__manage">
            <p
              class="dashboard__booking-space-info-text"
              v-html="formatAmount(totalReferralEarnings)"
            ></p>
          </div>
        </div>
        <!-- total pending payout balance -->
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            Pending Payout Balance
          </p>
          <div class="dashboard__manage">
            <p
              class="dashboard__booking-space-info-text"
              v-html="formatAmount(totalPayoutBalance)"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <!-- the select drop down for filter (commented out until when needed line 65-73) -->
    <!-- <select name="" v-model="sort" id="" class="form__select dashboard__filter">
      <option :value="null" disabled selected>Filter</option>
      <option value="all">All</option>
      <option value="pending">Pending</option>
      <option value="completed">Completed</option>
      <option value="paid">Paid</option>
      <option value="rejected">Rejected</option>
      <option value="declined">Declined</option>
    </select> -->
    <!-- the table showing the referrers earning -->
    <div
      class="dashboard__payment-history-wrap dashboard__overview-table"
    >
      <table class="dashboard__payment-history-table">
        <thead>
          <tr>
            <th class="dashboard__payment-history-table-heading"></th>
            <th class="dashboard__payment-history-table-heading">
              Tenants Name
            </th>
            <th class="dashboard__payment-history-table-heading">
              Space Name
            </th>
            <th class="dashboard__payment-history-table-heading">
              Referral Earnings
            </th>
            <th class="dashboard__payment-history-table-heading">
              Booking Date
            </th>
            <th class="dashboard__payment-history-table-heading">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="dashboard__table-row"
            v-for="(referreral, index) in referralEarnings"
            :key="index"
          >
            <td
              class="dashboard__payment-history-table-data dashboard__listing-table"
            >
              {{ pageNumber(index + 1) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ referreral.tenantName }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ referreral.spaceName }}
            </td>
            <td
              class="dashboard__payment-history-table-data"
              v-html="formatAmount(referreral.rewardAmount)"
            ></td>
            <td class="dashboard__payment-history-table-data">
              {{ formatDate(referreral.bookingDate) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              <span
                class="dashboard__payment-history-table-status"
                :class="[
                  { pending: referreral.status == 'pending' },
                  { approve: referreral.status == 'active' },
                  { approve: referreral.status == 'completed' },
                  { decline: referreral.status == 'declined' },
                  { decline: referreral.status == 'expired' },
                  { decline: referreral.status == 'unavailable' }
                ]"
                >{{ referreral.status | capitalize }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Empty booking result -->
    <!-- <div v-if="!loader && referralEarnings.length === 0 && !error">
      <empty-result />
    </div> -->
    <!-- error-->
    <div v-if="!loader && error">
      <error />
    </div>

    <div class="dashboard__pagination">
      <b-pagination
        v-if="referralEarnings.length > 0 && returnedData"
        pills
        v-model="curPage"
        :total-rows="count"
        :per-page="pageSize"
        prev-text="Prev"
        next-text="Next"
        first-number
        last-number
        @change="handlePagination"
      ></b-pagination>
    </div>
    <!-- the loader -->
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import { getReferrerDetails } from "../../../services/referral";
import EmptyResult from "../general/emptyResult.vue";
import Error from "../general/error.vue";
import { formatCurrencyAmount, formatReadbleDate } from "../../utils";
import { sort } from "semver";
export default {
  name: "referrerDetails",
  components: {
    loader,
    EmptyResult,
    Error
  },
  data: () => {
    return {
      referralEarnings: [], // the total referrers in the system
      loader: false,
      returnedData: true,
      numberOfReferrals: 0,
      referralCode: "",
      sort:"all",
      totalReferralEarnings: 0,
      totalPayoutBalance: "",
      currentPage: 1,
      pageSize: 20,
      count: 0,
      page: 1,
      status: "",
      error: false,
      userId: "",
      referrerName:"",
    };
  },
  methods: {
    // the function that fetches a single referrer details
    async getReferrerDetails(id) {
      this.loader = true;
      try {
        const response = await getReferrerDetails(id, this.getPages, this.pageSize, this.status);
        this.loader = false;
        this.referralEarnings = response.data.referralEarnings;
        this.numberOfReferrals = response.data.numberOfReferrals;
        this.referralCode = response.data.referralCode;
        this.referrerName = response.data.referrerName;
        this.totalReferralEarnings = response.data.totalReferalEarnings;
        this.totalPayoutBalance = response.data.totalPayoutBalance;
        this.returnedData = true;
      } catch (error) {
        this.loader = false;
        this.error = true;
      }
    },
    handlePagination(value) {
      this.currentPage = value;
      this.$router.push(
        `/referral-details/${this.userId}?page=${this.currentPage}&status=${this.status}`
      );
    },
    formatAmount(data) {
      return formatCurrencyAmount(data);
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    toBase64(data) {
      return btoa(data);
    },

    pageNumber(index) {
      if (this.currentPage < 2) {
        return index;
      } else {
        return this.pageSize * (this.currentPage - 1) + index;
      }
    }
  },
  watch: {
    $route() {
      this.getReferrerDetails(this.userId);
    },
    // the filter using dropdown (the select tag)
    sort(newValue) {
      this.currentPage = 1;
      if (newValue === "all") {
        this.status = "";
        this.$router.replace(`${this.userId}?page=1`);
        this.getReferrerDetails(this.userId);
      } else {
        this.status = newValue;
        this.$router.replace(`${this.userId}?page=1&status=${this.status}`);
        this.getReferrerDetails(this.userId);
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 1;
    },
    curPage: {
      get() {
        return this.$route.query.page || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    }
  },
  async mounted() {
    const { id } = this.$route.params;
    this.userId = id; // assigning the userId to the component data
    if (id) {
      await this.getReferrerDetails(id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/referralDetails.vue